import React from 'react';

export const useCallbackOnce = (callback: Function) => {
    const callbackHasBeenCalled = React.useRef(false);
    if (callbackHasBeenCalled.current) return;
    callback?.();
    callbackHasBeenCalled.current = true;
};
